import { render, staticRenderFns } from "./DataRetrievalDetails.vue?vue&type=template&id=584fcaee&"
import script from "./DataRetrievalDetails.vue?vue&type=script&lang=ts&"
export * from "./DataRetrievalDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports